<template>
  <div class="detail-ai-container">
    <div class="ai-thinking-box">
      <div class="ai-thinking-operate-box">
        <div class="ai-operate-container">
          <div class="ai-logo"></div>
          <div class="title-box mouse-hand" @click="toggleThinkingContent">风险研判</div>
          <div class="title-description mouse-hand" @click="toggleThinkingContent">帮你快速识别内容风险</div>
          <div
            class="ai-thinking-operate-all mouse-hand"
            :class="{
              'ai-thinking-operate-all-expand': !showThinkingContent,
            }"
            @click="toggleThinkingContent"
          >
          </div>
        </div>
      </div>
      <div v-show="showThinkingContent" class="ai-thinking-content">
        <div class="ai-thinking-operate-container">
          <div v-show="thinkingStep === 1 || thinkingStep === 2" class="ai-thinking-stage mouse-hand"  @click="toggleThinking">已深度思考</div>
          <div v-show="thinkingStep === 0" class="ai-thinking-stage">深度思考中{{ point }}</div>
          <div v-show="thinkingStep === 1 || thinkingStep === 2" class="ai-thinking-operate-text mouse-hand" @click="toggleThinking">{{ thinkingStep | toggleText }}</div>
          <div
            v-show="thinkingStep === 1 || thinkingStep === 2"
            class="ai-thinking-operate mouse-hand"
            :class="{
              'ai-thinking-expand': thinkingStep === 2,
            }"
            @click="toggleThinking"
          >
          </div>
        </div>
        <VueMarkdown v-show="thinkingStep === 0 || thinkingStep === 2" class="thinking-box" :source="thinkingCon"></VueMarkdown>
      </div>
    </div>
    <div v-show="showThinkingContent" class="ai-content-box">
      <div v-show="content.hasRisk !== null" class="ai-risk-judgment-box">
        <div class="ai-risk-judgment-title">
          <div class="title">是否有风险：</div>
          <div class="ai_copy_box" @click="copyAi">
            <div class="copy_blue_icon1"></div>
          </div>
        </div>
        <div
          class="risk-box"
          :class="{
            'no-risk': content.hasRisk === 0
          }"
        >
          {{ content.hasRisk === 1 ? '存在风险' :'无风险' }}
        </div>
      </div>
      <div v-if="content.riskReasons.length > 0" class="ai-risk-judgment-box">
        <div class="ai-risk-judgment-reason">
          <div class="title ai-risk-reason">风险原因：</div>
          <div v-for="(item, index) in content.riskReasons" v-show="item.label || item.content" :key="index" class="ai-risk-content">
            <span v-if="item.label" class="con-label">
              {{ item.label.replace(/\*\*/g, '') }}
              {{ item.content ? '：' : '' }}
            </span>
            <span v-if="item.content">{{ item.content.replace(/\*\*/g, '') }}</span>
          </div>
          <div v-show="content.riskReasons.length === 0" class="no-info">暂无</div>
        </div>
      </div>
      <div v-if="content.focusDepartment.length > 0" class="ai-risk-judgment-box pt-42">
        <div class="ai-risk-judgment-title">
          <div class="title">关注部门：</div>
        </div>
        <div v-for="(item, index) in content.focusDepartment" v-show="item.label || item.content" :key="index" class="ai-risk-content">
          <span v-if="item.label" class="con-label">
            {{ item.label.replace(/\*\*/g, '') }}
            {{ item.content ? '：' : '' }}
          </span>
          <span v-if="item.content">{{ item.content.replace(/\*\*/g, '') }}</span>
        </div>
        <div v-show="content.focusDepartment.length === 0" class="no-info">暂无</div>
      </div>
      <div v-if="content.disSuggestions.length > 0" class="ai-risk-judgment-box pt-42">
        <div class="ai-risk-judgment-title">
          <div class="title">处置建议：</div>
        </div>
        <div v-for="(item, index) in content.disSuggestions" v-show="item.label || item.content" :key="index" class="ai-risk-content">
          <span v-if="item.label" class="con-label">
            {{ item.label.replace(/\*\*/g, '') }}
            {{ item.content ? '：' : '' }}
          </span>
          <span v-if="item.content">{{ item.content.replace(/\*\*/g, '') }}</span>
        </div>
        <div v-show="content.disSuggestions.length === 0" class="no-info">暂无</div>
      </div>
    </div>
  </div>
</template>
<script>
import VueMarkdown from 'vue-markdown'
import { Notify } from 'vant';
import { fetchEventSource } from '@microsoft/fetch-event-source'
import { handleClipboard } from '../../../../../assets/js/clipboard'
import { getAssessment } from '@/api/judgment'
export default {
  name: 'DetailAi',
  components: { VueMarkdown },
  filters: {
    toggleText(val) {
      if (val === 1) { 
        return '展开'
      } else if (val === 2) {
        return '收起'
      }
      return ''
    }
  },
  data(){
    return {
      thinkingStep: -1, // 0 思考中 1 思考完成 - 关闭思考过程  2 思考完成 - 展开思考过程
      showThinkingContent: false,
      sti: null,
      point: '',
      thinkingCon: '',
      oThinkingCon: [],
      step: 'thinking',
      contentData: '',
      oContent: {
        hasRisk: 0, // 有无风险： 1 有 0 无
        riskReasons: [], // 风险原因
        focusDepartment: [], // 关注部门
        disSuggestions: [] // 处置建议
      },
      content: {
        hasRisk: null,
        riskReasons: [],
        focusDepartment: [],
        disSuggestions: []
      },
      keyName: 'riskReasons'
    }
  },
  props: {
    detailInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    thinkingStep(newVal) {
      if (newVal === 0) {
        let index = 1
        const dic = {
          1: '.',
          2: '..',
          3: '...'
        }
        /** 控制思考中点的显示个数 */
        this.sti = setInterval(() => {
          this.point = dic[index % 4]
          index++
        }, 500)
      } else {
        clearInterval(this.sti)
      }
    }
  },
  methods: {
    toggleThinkingContent() {
      this.showThinkingContent = !this.showThinkingContent
      if (this.showThinkingContent && !this.thinkingCon) this.getAssessment()
    },
    toggleThinking() {
      if (this.thinkingStep === 1) {
        this.thinkingStep = 2
      } else if (this.thinkingStep === 2) {
        this.thinkingStep = 1
      }
    },
    copyAi() {
      const hasRiskStr = `是否有风险：${this.content.hasRisk === 1 ? '存在风险' : '无风险'}`
      let riskReasonsStr = `风险原因：`
      let focusDepartmentStr = `关注部门：`
      let disSuggestionsStr = `处置建议：`
      if (this.content.riskReasons.length > 0) {
        this.content.riskReasons.forEach(item => {
          riskReasonsStr += `\n${item.label ? item.label.replace(/\*\*/g, '') + (item.content ? '：' : '') : ''}${item.content.replace(/\*\*/g, '')}`
        })
      } else {
        riskReasonsStr += `\n暂无`
      }
      if (this.content.focusDepartment.length > 0) {
        this.content.focusDepartment.forEach(item => {
          focusDepartmentStr += `\n${item.label ? item.label.replace(/\*\*/g, '') + (item.content ? '：' : '') : ''}${item.content.replace(/\*\*/g, '')}`
        })
      } else {
        focusDepartmentStr += `\n暂无`
      }
      if (this.content.disSuggestions.length > 0) {
        this.content.disSuggestions.forEach(item => {
          disSuggestionsStr += `\n${item.label ? item.label.replace(/\*\*/g, '') + (item.content ? '：' : '') : ''}${item.content.replace(/\*\*/g, '')}`
        })
      } else {
        disSuggestionsStr += `\n暂无`
      }
      const str = `${hasRiskStr}\n${riskReasonsStr}\n${focusDepartmentStr}\n${disSuggestionsStr}`
      handleClipboard(str, event, () => {
        Notify({
          message: '复制成功',
          duration: 1000,
          color: "",
          className: "notifyNew",
          background: ''
        })
      }, () => {
        Notify({
          message: '复制失败！',
          duration: 1000,
          color: "",
          className: "notifyErr",
          background: ''
        })
      })
    },
    async getAssessment() {
      const params = {
        openId: this.$route.query.openid,
        url: this.detailInfo.url
      }
      this.thinkingStep = 0
      const res = await getAssessment(params)
      const { data, code } = res.data
      if (code === 200) {
        this.thinkingStep = 1
        if (data.reasoningContent || data.content) {
          this.thinkingCon = data.reasoningContent.replace(/\n\n/g, '<div class="line-break"></div>')
          data.content = data.content.replace(/\*\*/g, '')
          this.oContent = this.formattingContent(data.content.replace(/[\r\n]+/g, ''))
          this.content = JSON.parse(JSON.stringify(this.oContent))
        } else {
          this.getDeepAssessment()
        }
      }
    },
    getDeepAssessment() {
      this.thinkingStep = 0 // 开始思考
      const requestData = {
        openId: this.$route.query.openid || '',
        url: this.detailInfo.url,
        title: this.detailInfo.title,
        content: this.detailInfo.content,
        author: this.detailInfo.author,
        webName: this.detailInfo.webName,
        forwardCount: 0, //this.itemdata.forwardCount 转发数
        replyCount: 0, //this.itemdata.replyCount 评论数
        simhashCount: 0, // 相似信息数
        authorFansCount: 0, // this.itemdata.authorInfo.authorFansCount粉丝数
        attitude: 2 // this.itemdata.attitude倾向性
      }
      let first = true
      const obj = {
        contentData: ''
      }
      fetchEventSource('/api/ai/stream/risk/assessment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData),
        openWhenHidden: true, // 取消visibilityChange事件
        onopen: () => {},
        onmessage: async(ev) => {
          if (ev.event === 'reasoningContent') {
            if (first) {
              first = false
              this.showThinkJump()
            }
            if (!ev.data.includes('\\n')) {
              this.oThinkingCon.push(ev.data)
            } else {
              let resData = ''
              if (/\\n\\n/g.test(ev.data)) {
                resData = ev.data.replace(/\\n\\n/g, '<div class="line-break"></div>')
              } else if (/\\n/g.test(ev.data)) {
                resData = ev.data.replace(/\\n/g, '<div class="line-break"></div>')
              } else {
                resData = ev.data
              }
              this.oThinkingCon.push(resData)
            }
          }
          if (ev.event === 'content') {
            this.contentData += ev.data.replace(/\\n/g, '')
            obj.contentData += ev.data.replace(/\\n/g, '')
            this.formattingContentStep1(obj, 'hasRisk')
          }
          if (ev.data === 'done') {
            this.formattingContentStep1(obj, 'end')
            this.step = 'end'
            return
          }
        },
        onerror: () => {
          throw new Error('连接出错')
        }
      })
    },
    formattingContent(data) {
      const result = {
        hasRisk: null, // 有无风险： 1 有 0 无
        riskReasons: [], // 风险原因
        focusDepartment: [], // 关注部门
        disSuggestions: [] // 处置建议
      }
      const formatData = data
      let iRisk = formatData.indexOf('有无风险') // 大于-1， 说明存在有无风险
      if (iRisk === -1) iRisk = formatData.indexOf('有风险')
      if (iRisk === -1) iRisk = formatData.indexOf('无风险')
      if (iRisk === -1) iRisk = formatData.indexOf('存在风险')
      if (iRisk === -1) iRisk = formatData.indexOf('暂无风险')
      const iRiskReason = formatData.indexOf('风险原因') // 大于-1， 说明存在风险原因
      const igzbm = formatData.indexOf('关注部门') // 大于-1， 说明存在关注部门
      const iDepartment = formatData.indexOf('处置建议') // 大于-1， 说明存在处置建议
      result.hasRisk = formattingRisk(formatData, iRisk, iRiskReason)
      result.riskReasons = formattingReason(formatData, iRiskReason, igzbm)
      result.focusDepartment = formattingReason(formatData, igzbm, iDepartment)
      result.disSuggestions = formattingReason(formatData, iDepartment, 1000)
      function formattingRisk(str, start, end) {
        const str1 = str.slice(start, end)
        let res = 0
        if (str1.includes('存在风险') || str1.includes('有风险')) res = 1
        return res
      }
      function formattingReason(str, start, end) {
        let str1 = str.slice(start, end)
        str1 = str1.replace('风险原因：', '')
        str1 = str1.replace('关注部门：', '')
        str1 = str1.replace('处置建议：', '')
        const cStr = str1.replace(/\s+/g, '')
        const res = []
        if (/(?=[\s\S]*1\.)(?=[\s\S]*2\.)/.test(cStr)) {
          const arr = cStr.split(/(?=\d+\.(?!\d))/g)
          dealWith(arr)
          for (let i = 0; i < arr.length; i++) {
            if (!arr[i].trim()) continue
            const iArr = arr[i].split('：')
            if (iArr.length > 1) {
              let str = ''
              iArr.forEach((item, index) => { // 防止正文中包含：
                if (index > 0) str += item
              })
              if (!str.endsWith('。') && !str.endsWith('；')) {
                str += '。'
              }
              res.push({
                label: `${iArr[0]}`,
                content: str
              })
            } else if (iArr.length === 1) {
              if (iArr[0] && !iArr[0].endsWith('。') && !iArr[0].endsWith('；')) {
                iArr[0] += '。'
              }
              res.push({
                label: '',
                content: `${iArr[0]}`
              })
            } else { // 其他情况
              let str = ''
              iArr.forEach(item => {
                str += item
              })
              if (!str.endsWith('。') && !str.endsWith('；')) {
                str += '。'
              }
              res.push({
                label: '',
                content: str
              })
            }
          }
        } else { // 不分1、2、3的方式
          const str = cStr
          res.push({
            label: str,
            content: ''
          })
        }
        return res
      }
      return result
      function dealWith(arr) {
        let slowPoint = 0
        let quickPoint = 1
        while (quickPoint < arr.length) {
          if (!arr[slowPoint]) {
            arr.splice(slowPoint, 1)
            continue
          } else if (arr[slowPoint].includes('：') && !arr[quickPoint].includes('：') && !/^\d+\./.test(arr[quickPoint])) {
            const quickItem = arr.splice(quickPoint, 1)
            arr[slowPoint] += quickItem[0]
            continue
          } else if (arr[slowPoint][0] === arr[quickPoint][0]) {
            const quickItem = arr.splice(quickPoint, 1)
            arr[slowPoint] += quickItem[0]
            continue
          }
          slowPoint++
          quickPoint++
        }
      }
    },
    formattingContentStep(data, key) {
      const result = {
        hasRisk: null, // 有无风险： 1 有 0 无
        riskReasons: [], // 风险原因
        focusDepartment: [], // 关注部门
        disSuggestions: [] // 处置建议
      }
      const formatData = data
      let iRisk = formatData.indexOf('有无风险') // 大于-1， 说明存在有无风险
      if (iRisk === -1) iRisk = formatData.indexOf('有风险')
      if (iRisk === -1) iRisk = formatData.indexOf('无风险')
      if (iRisk === -1) iRisk = formatData.indexOf('存在风险')
      if (iRisk === -1) iRisk = formatData.indexOf('暂无风险')
      const iRiskReason = formatData.indexOf('风险原因') // 大于-1， 说明存在风险原因
      const igzbm = formatData.indexOf('关注部门') // 大于-1， 说明存在关注部门
      const iDepartment = formatData.indexOf('处置建议') // 大于-1， 说明存在处置建议
      if (key === 'hasRisk' && iRisk > -1 && iRiskReason > -1) {
        result.hasRisk = formattingRisk(formatData, iRisk, iRiskReason)
        this.step = 'risk'
      } else if (key === 'riskReasons' && iRiskReason > -1 && igzbm > -1) {
        result.riskReasons = formattingReason(formatData, iRiskReason, igzbm)
        this.step = 'riskReason'
      } else if (key === 'focusDepartment' && igzbm > -1 && iDepartment > -1) {
        result.focusDepartment = formattingReason(formatData, igzbm, iDepartment)
      } else if (key === 'disSuggestions') {
        result.disSuggestions = formattingReason(formatData, iDepartment, 1000)
      }
      function formattingRisk(str, start, end) {
        const str1 = str.slice(start, end)
        let res = 0
        if (str1.includes('存在风险') || str1.includes('有风险')) res = 1
        return res
      }
      function formattingReason(str, start, end) {
        let str1 = str.slice(start, end)
        str1 = str1.replace('风险原因：', '')
        str1 = str1.replace('关注部门：', '')
        str1 = str1.replace('处置建议：', '')
        const cStr = str1.replace(/\s+/g, '')
        const res = []
        if (/(?=[\s\S]*1\.)(?=[\s\S]*2\.)/.test(cStr)) {
          const arr = cStr.split(/(?=\d+\.(?!\d))/g)
          dealWith(arr)
          for (let i = 0; i < arr.length; i++) {
            if (!arr[i].trim()) continue
            const iArr = arr[i].split('：')
            if (iArr.length > 1) {
              let str = ''
              iArr.forEach((item, index) => { // 防止正文中包含：
                if (index > 0) str += item
              })
              if (!str.endsWith('。') && !str.endsWith('；')) {
                str += '。'
              }
              res.push({
                label: `${iArr[0]}`,
                content: str
              })
            } else if (iArr.length === 1) {
              if (iArr[0] && !iArr[0].endsWith('。') && !iArr[0].endsWith('；')) {
                iArr[0] += '。'
              }
              res.push({
                label: '',
                content: iArr[0]
              })
            } else { // 其他情况
              let str = ''
              iArr.forEach(item => {
                str += item
              })
              if (!str.endsWith('。') && !str.endsWith('；')) {
                str += '。'
              }
              res.push({
                label: '',
                content: str
              })
            }
          }
        } else { // 不分1、2、3的方式
          const str = cStr
          res.push({
            label: str,
            content: ''
          })
        }
        return res
      }
      return result[key]
      function dealWith(arr) {
        let slowPoint = 0
        let quickPoint = 1
        while (quickPoint < arr.length) {
          if (!arr[slowPoint]) {
            arr.splice(slowPoint, 1)
            continue
          } else if (arr[slowPoint].includes('：') && !arr[quickPoint].includes('：') && !/^\d+\./.test(arr[quickPoint])) {
            const quickItem = arr.splice(quickPoint, 1)
            arr[slowPoint] += quickItem[0]
            continue
          } else if (arr[slowPoint][0] === arr[quickPoint][0]) {
            const quickItem = arr.splice(quickPoint, 1)
            arr[slowPoint] += quickItem[0]
            continue
          }
          slowPoint++
          quickPoint++
        }
      }
    },
    formattingContentStep1(obj, status) {
      const formattingRisk = (obj, start, end) => {
        const str1 = obj.contentData.slice(start, end)
        obj.contentData = obj.contentData.slice(end)
        let res = 0
        if (str1.includes('存在风险') || str1.includes('有风险')) res = 1
        this.oContent.hasRisk = res
      }
      const formattingReason = (obj, status) => {
        const addItem = (keyName) => {
          this.oContent[keyName].push({ label: '', content: '' })
        }
        const sliceStr = (startIndex) => {
          const str = obj.contentData.slice(0, startIndex)
          const l = this.oContent[this.keyName].length - 1
          if (this.oContent[this.keyName][l].content) {
            this.oContent[this.keyName][l].content += str
          } else {
            this.oContent[this.keyName][l].label += str
          }
          obj.contentData = obj.contentData.slice(startIndex)
        }
        const dealColon = (arr) => {
          const l = this.oContent[this.keyName].length - 1
          this.oContent[this.keyName][l].label += arr[0]
          this.oContent[this.keyName][l].content += arr[1] || ' '
        }
        const blackList = `风险原因：关注部门处置建议.*`
        if (status !== 'end' && obj.contentData && (blackList.includes(obj.contentData[obj.contentData.length-1])) || /\d$/.test(obj.contentData[obj.contentData.length-1])) return
        /**
         * 1. 找字符串中的关键词“风险原因：”、“关注部门：”、“处置建议：”
         *  如果找到关键词， 先把关键词之前的字符串给前一个数组，再创建一个新的数组
         */
        obj.contentData = obj.contentData.replace(/\*\*/g, '')
        const fxIndex = obj.contentData.indexOf('风险原因：')
        const depIndex = obj.contentData.indexOf('关注部门：')
        const suggIndex = obj.contentData.indexOf('处置建议：')
        if (fxIndex > -1) {
          this.keyName = 'riskReasons'
          addItem(this.keyName)
          obj.contentData = obj.contentData.replace('风险原因：', '')
        } else if (depIndex > -1) {
          /**
           * 1. 将关注部门之前的字符串加到风险原因的选项中
           * 2. 给关注部门增加一项
           */
          sliceStr(depIndex)
          this.keyName = 'focusDepartment'
          addItem('focusDepartment')
          obj.contentData = obj.contentData.replace('关注部门：', '')
        } else if (suggIndex > -1) {
          sliceStr(suggIndex)
          this.keyName = 'disSuggestions'
          addItem('disSuggestions')
          obj.contentData = obj.contentData.replace('处置建议：', '')
        }
        /**
         * 以关注部门等字眼结尾或者以数字结尾需要重点关注，先返回重新循环
         */
        /**
         * 如果字符串中有“1.xxx”、“2.xxx”这样的序号， 那么做如下操作
         * 1. 如果this.oContent[keyName]的长度为1， 且 label 和 content 选项都是空， 那么直接跳过
         * 2. 如果 且 label 和 content 选项都非空， 那么将 "1."、"2."之前的字符串都添加到上一个选项当中，再创建一个新的空选项
         */
        const numIndex = obj.contentData.search(/(?=\d+\.(?!\d))/g)
        const colonIndex = obj.contentData.search('：')
        let l = this.oContent[this.keyName].length - 1
        if (numIndex > -1 && this.oContent[this.keyName][l].label) {
          sliceStr(numIndex)
          addItem(this.keyName)
          return
        }
        /**
         * 如果字符串中有“：”， 那么做如下操作:
         * 1. 将 “：” 之前的字符串加到label当中；
         * 2. 将 “：”之后的字符串加到content当中。
         */
        if (colonIndex > -1) {
          const resArr = obj.contentData.split('：')
          dealColon(resArr)
          obj.contentData = ''
          return
        }
        /**
         * 若 step 是 "end" 说明已经到了最后部分， 直接添加到关注部门的最后
         */
        sliceStr(obj.contentData.length)
      }
      const result = {
        hasRisk: null, // 有无风险： 1 有 0 无
        riskReasons: [], // 风险原因
        focusDepartment: [], // 关注部门
        disSuggestions: [] // 处置建议
      }
      let iRisk = obj.contentData.indexOf('有无风险') // 大于-1， 说明存在有无风险
      if (iRisk === -1) iRisk = obj.contentData.indexOf('有风险')
      if (iRisk === -1) iRisk = obj.contentData.indexOf('无风险')
      if (iRisk === -1) iRisk = obj.contentData.indexOf('存在风险')
      if (iRisk === -1) iRisk = obj.contentData.indexOf('暂无风险')
      const iRiskReason = obj.contentData.indexOf('风险原因') // 大于-1， 说明存在风险原因
      if (iRisk > -1 && iRiskReason > -1) {
        result.hasRisk = formattingRisk(obj, iRisk, iRiskReason)
        this.step = 'risk'
      } else if (this.step !== 'thinking'){
        formattingReason(obj, status)
      }
    },
    showThinkJump() {
      const sti = setInterval(() => {
        if (this.oThinkingCon.length > 0) {
          const res = this.oThinkingCon.splice(0, 1)[0]
          this.thinkingCon += res
        }
        if (this.oThinkingCon.length === 0 && this.step !== 'thinking') {
          clearInterval(sti)
          this.thinkingStep = 1
          this.showContentJump1()
          // this.showThikingText = false
          // this.showThinking = false
        }
      }, 10)
    },
    async showContentJump() {
      const sleep = async(key) => { // 时间锁
        return new Promise(res => {
          const sti = setInterval(() => {
            if (Array.isArray(this.oContent[key])) {
              if (this.oContent[key].length > 0) {
                clearInterval(sti)
                res()
              }
            } else {
              if (this.oContent[key] !== null) {
                clearInterval(sti)
                res()
              }
            }
          }, 10)
        })
      }
      const showRick = () => {
        this.content.hasRisk = this.oContent.hasRisk
      }
      const showRiskReasons = (key) => {
        const ele = this.oContent[key]
        return new Promise((res) => {
          let i = 0
          const sti = setInterval(() => {
            if (!ele[i]) {
              clearInterval(sti)
              res()
              return
            }
            if (!this.content[key][i]) {
              this.content[key].push({
                label: '',
                content: ''
              })
            }
            if (ele[i].label && this.content[key][i].label.length < ele[i].label.length) {
              this.content[key][i].label += ele[i].label.slice(this.content[key][i].label.length, this.content[key][i].label.length + 2)
              return
            }
            if (ele[i].content && this.content[key][i].content.length < ele[i].content.length) {
              this.content[key][i].content += ele[i].content.slice(this.content[key][i].content.length, this.content[key][i].content.length + 2)
              return
            }
            if (!ele[i].content || this.content[key][i].content.length >= ele[i].content.length) {
              i++
            }
          }, 10)
        })
      }
      // 处理是否有风险
      await sleep('risk')
      showRick()
      await sleep('riskReasons')
      await showRiskReasons('riskReasons')
      await sleep('focusDepartment')
      await showRiskReasons('focusDepartment')
      await sleep('disSuggestions')
      await showRiskReasons('disSuggestions')
    },
    async showContentJump1() {
      const sleep = async(key) => { // 时间锁
        return new Promise(res => {
          const sti = setInterval(() => {
            if (Array.isArray(this.oContent[key])) {
              if (this.oContent[key].length > 0) {
                clearInterval(sti)
                res()
              }
            } else {
              if (this.oContent[key] !== null) {
                clearInterval(sti)
                res()
              }
            }
          }, 20)
        })
      }
      const showRick = () => {
        this.content.hasRisk = this.oContent.hasRisk
      }
      const showRiskReasons = (key) => {
        const nextKeyDic = {
          riskReasons: 'focusDepartment',
          focusDepartment: 'disSuggestions',
          disSuggestions: null
        }
        const ele = this.oContent[key]
        return new Promise((res) => {
          let i = 0
          const sti = setInterval(() => {
            if ((!ele[i] && nextKeyDic[key] && this.oContent[nextKeyDic[key]].length > 0) || !ele[i] && !nextKeyDic[key]) {
              clearInterval(sti)
              res()
              return
            }
            if (!this.content[key][i]) {
              this.content[key].push({
                label: '',
                content: ''
              })
            }
            if (ele[i] && ele[i].label && this.content[key][i].label.length < ele[i].label.length) {
              this.content[key][i].label += ele[i].label.slice(this.content[key][i].label.length, this.content[key][i].label.length + 2)
              return
            }
            if (ele[i] && ele[i].content && this.content[key][i].content.length < ele[i].content.length) {
              this.content[key][i].content += ele[i].content.slice(this.content[key][i].content.length, this.content[key][i].content.length + 2)
              return
            }
            /**
             * i++ 的情况汇总：
             * 1. 展示content长度大于等于资源content长度，且资源的下一个元素有值，或者下一个部分有值了，或者nextKeyDic[key]
             * 2. 
             */
            try {
              if (
                  (this.content[key][i].content && this.content[key][i].content.length >= ele[i].content.length ||
                  this.content[key][i].label && this.content[key][i].label.length >= ele[i].label.length) &&
                  (ele[i + 1] || (!nextKeyDic[key] && this.step === 'end') || this.oContent[nextKeyDic[key]] && this.oContent[nextKeyDic[key]].length > 0)
                ) {
                i++
              }
            } catch(e) {}
          }, 20)
        })
      }
      // 处理是否有风险
      await sleep('risk')
      showRick()
      await showRiskReasons('riskReasons')
      await showRiskReasons('focusDepartment')
      await showRiskReasons('disSuggestions')
    }
  },
  mounted() {
    // this.getAssessment()
    // let data = `\n\n有无风险：存在风险  \n风险原因：  \n1.社会安全风险：内容聚焦锂电车火灾隐患，高温天气下锂电池自燃事故高发易引发公众恐慌，若视频未提供科学防护指引或夸大风险，可能加剧民众对锂电车安全性的非理性担忧，触发群体性舆情。  \n2.行业信任风险：锂电车产业为新能源重点领域，负面内容若传播量级较高（如点赞>10万、转发>5万），可能损害行业声誉，影响市场消费信心及政策支持力度，需结合实时传播数据评估影响范围。  \n3.信息真实性风险：未明确引用权威事故数据或安全标准，存在片面渲染风险嫌疑，易被恶意篡改后用于散布虚假恐慌信息。  \n\n关注部门：  \n1.网络安全应急指挥中心,监测舆情扩散态势，识别是否存在恶意炒作账号或异常传播链路、  \n2.市场监管总局产品质量监督司，联动核查锂电车行业质量安全现状，发布权威安全警示、  \n3.工业和信息化部装备工业司，强化锂电车生产准入与技术标准宣导，对冲不实信息影响、  \n4.消防救援局，协同制作电动车规范使用指南，定向推送至社区网格及社交平台、  \n\n处置建议：网信办联合平台实时监控视频传播数据，若单日转发量超1万次则启动限流，同步置顶应急管理部电动车安全使用科普内容。工信部门组织头部锂电企业48小时内发布季度安全白皮书，市场监管部门开展专项抽检并公示结果，消协开通投诉绿色通道。消防救援部门针对视频提及场景（如小区充电棚）开展隐患排查，联合社区组织应急演练，转化线上风险为线下治理效能。`
    // let data1 = { contentData: '' }
    // let first = true
    // const sti = setInterval(() => {
    //   if (data.length < 5) {
    //     this.step = 'end'
    //   }
    //   if (first) {
    //     first = false
    //     this.showContentJump1()()
    //   }
    //   data1.contentData += data.slice(0, 2)
    //   data = data.slice(2)
    //   this.formattingContentStep1(data1, data.length < 5 ? 'end' : 'hasRisk')
    //   if (data.length === 0) {
    //     console.log(this.oContent);
    //     clearInterval(sti)
    //   }
    // }, 10)
  }
}
</script>
<style scoped>
@import url('./index.css');
</style>
 